// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".course_scheduling_associate-layout .add-association-section {\n  padding-left: 15px;\n  padding-right: 15px; }\n\n.course_scheduling_associate-layout .association-item .association-label {\n  display: flex; }\n  .course_scheduling_associate-layout .association-item .association-label .association-label-name {\n    flex: 1; }\n", ""]);
// Exports
module.exports = exports;
